import { Images } from "../../../Images";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import BlocksBonusSkillNode from "./BlocksBonusSkillNode";
import { SkillIds } from "../SkillIds";
import SkillType from "../SkillType";

export default class BlocksBonusSkill extends SkillType {
    /**
     * @param {Totals} totals
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     */
    constructor(totals, values, mineDamageLogic) {
        super(SkillIds.BLOCKS_BONUS);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        const inc = 250;
        let cost = 500;
        let purchaseIndex = 0;

        const blocksBonus1 = this.addNode(new BlocksBonusSkillNode('blocksBonus1', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus2 = this.addNode(new BlocksBonusSkillNode('blocksBonus2', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus3 = this.addNode(new BlocksBonusSkillNode('blocksBonus3', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus4 = this.addNode(new BlocksBonusSkillNode('blocksBonus4', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus5 = this.addNode(new BlocksBonusSkillNode('blocksBonus5', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus6 = this.addNode(new BlocksBonusSkillNode('blocksBonus6', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus7 = this.addNode(new BlocksBonusSkillNode('blocksBonus7', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus8 = this.addNode(new BlocksBonusSkillNode('blocksBonus8', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus9 = this.addNode(new BlocksBonusSkillNode('blocksBonus9', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus10 = this.addNode(new BlocksBonusSkillNode('blocksBonus10', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus11 = this.addNode(new BlocksBonusSkillNode('blocksBonus11', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus12 = this.addNode(new BlocksBonusSkillNode('blocksBonus12', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus13 = this.addNode(new BlocksBonusSkillNode('blocksBonus13', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus14 = this.addNode(new BlocksBonusSkillNode('blocksBonus14', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus15 = this.addNode(new BlocksBonusSkillNode('blocksBonus15', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus16 = this.addNode(new BlocksBonusSkillNode('blocksBonus16', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus17 = this.addNode(new BlocksBonusSkillNode('blocksBonus17', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus18 = this.addNode(new BlocksBonusSkillNode('blocksBonus18', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus19 = this.addNode(new BlocksBonusSkillNode('blocksBonus19', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus20 = this.addNode(new BlocksBonusSkillNode('blocksBonus20', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const blocksBonus21 = this.addNode(new BlocksBonusSkillNode('blocksBonus21', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));
        


        blocksBonus1.addChildNode(blocksBonus2);
        blocksBonus2.addChildNode(blocksBonus3);
        blocksBonus3.addChildNode(blocksBonus4);
        blocksBonus4.addChildNode(blocksBonus5);
        blocksBonus5.addChildNode(blocksBonus6);
        blocksBonus6.addChildNode(blocksBonus7);
        blocksBonus7.addChildNode(blocksBonus8);

        blocksBonus8.addChildNode(blocksBonus9);
        blocksBonus9.addChildNode(blocksBonus10);
        blocksBonus10.addChildNode(blocksBonus11);
        blocksBonus11.addChildNode(blocksBonus12);
        blocksBonus12.addChildNode(blocksBonus13);
        blocksBonus13.addChildNode(blocksBonus14);
        blocksBonus14.addChildNode(blocksBonus15);

        blocksBonus15.addChildNode(blocksBonus16);
        blocksBonus16.addChildNode(blocksBonus17);
        blocksBonus17.addChildNode(blocksBonus18);
        blocksBonus18.addChildNode(blocksBonus19);
        blocksBonus19.addChildNode(blocksBonus20);
        blocksBonus20.addChildNode(blocksBonus21);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = -1;
        const startY = -16;

        blocksBonus1.setPosition(startX, startY);
        blocksBonus2.setPosition(startX - 1, startY);
        blocksBonus3.setPosition(startX - 2, startY);
        blocksBonus4.setPosition(startX - 3, startY);
        blocksBonus5.setPosition(startX - 4, startY);
        blocksBonus6.setPosition(startX - 5, startY);
        blocksBonus7.setPosition(startX - 6, startY);

        blocksBonus8.setPosition(startX - 6, startY - 1);
        blocksBonus9.setPosition(startX - 5, startY - 1);
        blocksBonus10.setPosition(startX - 4, startY - 1);
        blocksBonus11.setPosition(startX - 3, startY - 1);
        blocksBonus12.setPosition(startX - 2, startY - 1);
        blocksBonus13.setPosition(startX - 1, startY - 1);
        blocksBonus14.setPosition(startX, startY - 1);

        blocksBonus15.setPosition(startX, startY - 2);
        blocksBonus16.setPosition(startX - 1, startY - 2);
        blocksBonus17.setPosition(startX - 2, startY - 2);
        blocksBonus18.setPosition(startX - 3, startY - 2);
        blocksBonus19.setPosition(startX - 4, startY - 2);
        blocksBonus20.setPosition(startX - 5, startY - 2);
        blocksBonus21.setPosition(startX - 6, startY - 2);

    }
    
}